module.exports = __webpack_public_path__ + "img/BarterBook.a8b99c37.png";